var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"public_css_module personal_right_box message_page"},[_vm._m(0),_c('div',{staticClass:"main"},[_c('TeacherArticle')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"personal_top_header"},[_c('div',{staticClass:"leftResearch"},[_c('div',{staticClass:"page_title"},[_vm._v("我的文章")])])])
}]

export { render, staticRenderFns }